"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var ValidationContext_1 = require("@react-form-fields/core/components/ValidationContext");

var React = require("react");

var FormValidation =
/** @class */
function (_super) {
  tslib_1.__extends(FormValidation, _super);

  function FormValidation() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.bindValidationContext = function (validationContext) {
      _this.validationContext = validationContext;
    };

    _this.onSubmit = function (e) {
      e && e.preventDefault && e.preventDefault();
      e && e.stopPropagation && e.stopPropagation();

      var isValid = _this.validationContext.isValid(true);

      _this.props.onSubmit(isValid);
    };

    _this.isValid = function (formSubmitted) {
      if (formSubmitted === void 0) {
        formSubmitted = true;
      }

      return _this.validationContext.isValid(formSubmitted);
    };

    _this.reset = function () {
      _this.validationContext.reset();
    };

    return _this;
  }

  FormValidation.prototype.render = function () {
    return React.createElement("form", {
      noValidate: true,
      onSubmit: this.onSubmit
    }, React.createElement(ValidationContext_1.default, {
      ref: this.bindValidationContext
    }, this.props.children));
  };

  return FormValidation;
}(React.PureComponent);

exports.default = FormValidation;